module.exports = __webpack_public_path__ + "static/index/img/baikal-501.612697e1.jpg";